import React from "react";
import { Popover } from "react-bootstrap";

const UgPgPopover = (obj) => {
return (
    <Popover id="popover_idp_ug_pg">
      <div className="popover_blk">
          <div
          className="popover_content"
          dangerouslySetInnerHTML={{
              __html: obj?.caption,
          }}
          />
      </div>
    </Popover>
  );
}; 
export default UgPgPopover;
